import { TournamentUpdateInput } from '@repo/common-types';
import { updateTournamentRest } from '@/services/tournaments/tournaments-service';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useUpdateTournament = (tournamentId: string, { onSuccess }: { onSuccess?: () => void } = {}) => {
  const queryClient = useQueryClient();
  const { mutateAsync: updateTournament } = useMutation({
    mutationFn: (data: Partial<TournamentUpdateInput>) => updateTournamentRest(tournamentId, data),
    onSuccess: (updatedTournament) => {
      queryClient.setQueryData(['tournament', tournamentId], updatedTournament);
      onSuccess?.();
    },
  });

  return { updateTournament };
};

export default useUpdateTournament;
